export const names = ["Dea", "Lidia", "Flavio", "Roberto"];
export const colors = ["#f106af", "#07f196", "#0a29f8", "#398507"];
export const daysPerPerson = 2;
export const initialDate = new Date(2023, 7, 2);